var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.coaching)?_c('coachingview',{attrs:{"coaching":_vm.coaching,"user":_vm.user},on:{"close":_vm.close}}):_vm._e(),_c('loader',{attrs:{"loaderenabled":_vm.loaderenabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }